import DefaultComponent from "./components/DefaultComponent.vue";
import ParentTabComponent from "./components/ParentTabComponent/ParentTabComponent.vue";
import ParentTabComponentAgency from "./components/ParentTabComponent/ParentTabComponentAgency.vue";
import LevelComponent from "./components/Mylevel/LevelComponent.vue";
import HistoryTabComponent from "./components/LuckyNumber/HistoryTabComponent.vue";
import HistoryDetails from "./components/LuckyNumber/HistoryDetails.vue";
import StatisticsTabComponent from "./components/LuckyNumber/StatisticsTabComponent.vue";
import LuckyNumberRules from "./components/LuckyNumber/LuckyNumberRules.vue";
import LuckyRewards from "./components/LuckyNumber/LuckyRewards.vue";
import FlipCoinHistoryTabComponent from "./components/FlipCoin/HistoryTabComponent.vue";
import FlipCoinHistoryDetails from "./components/FlipCoin/FlipCoinHistoryDetails.vue";
import FlipCoinRules from "./components/FlipCoin/FlipCoinRules.vue";
import Freetarget from "./components/Freetarget/FreetargetComp.vue";
import FreetargetUpdate from "./components/Freetarget/FreetargetUpdate.vue";

import RewardBlastRule from "./components/TargetRules/RewardBlastRule.vue";
import WeeklyTargetRule from "./components/TargetRules/WeeklyTargetRule.vue"; 

// import WeeklyTarget from "./components/WeeklyTarget/WeeklyTarget.vue";
import WeeklyTargetPolicy from "./components/WeeklyTarget/WeeklyTargetPolicy.vue";
import WeeklyTargetPolicyStatus3 from "./components/WeeklyTarget/WeeklyTargetPolicy_status3.vue";



import BecomeAgency from "./components/BecomeAgency/Become_agency.vue";
// import InviteAgency from "./components/BecomeAgency/InviteAgency.vue";
import GetAgentListFromAgency from "./components/BecomeAgency/GetAgentListFromAgency.vue"
import InviteSubAgent from "./components/BecomeAgency/InviteSubAgent.vue";
import CongratulationsScreen from "./components/BecomeAgency/CongratulationsScreen.vue";
 
// import MidnightTarget from "./components/WeeklyTarget/MidnightTarget.vue";
import TargetComponent from "./components/WeeklyTarget/TargetComponent.vue" 
import FansRankingTabs from "./components/FansRanking/FansRankingTabs.vue";
import TopHosts from "./components/TopHosts/TopHosts.vue";
import AgencyCentre from "./components/AgencyComponent/AgencyCentre.vue";
import AgencyTeamList from "./components/AgencyComponent/AgencyTeamList.vue";
import TeamIncomeOverview from "./components/AgencyComponent/TeamIncomeOverview.vue";
import GameCompaign from "./components/GameCompaign/GameCompaign.vue";
import TradeAccount from "./components/TradeAccountComponent/TradeAccount.vue";
import TradeTransectionHistory from "./components/TradeAccountComponent/TradeTransectionHistory.vue";
import PayoutHistory from "./components/TradeAccountComponent/PayoutHistory.vue"
import OnlineRechargeBonus from "./components/OnlineRechargeBonus/OnlineRechargeBonus.vue";

import RankTabComponent from "./components/CarGame/RankTabComponent.vue"
import RaceRewardsComponent from "./components/CarGame/RaceRewardsComponent.vue"

import GoldCoinBattle from "./components/GoldCoinBattle/GoldCoinBattle.vue"
import GoldCoinRewardRaceGame from "./components/GoldCoinBattle/GoldCoinRewardRaceGame.vue"

import NotAllowed from "./components/NotAllowed.vue"
import { createRouter, createWebHistory } from "vue-router";
import EventCenter from "./components/EventCenter/EventCenter.vue";

// Detect In-App / WebView / PWA
function isInAppOrWebView() {
  const ua = navigator.userAgent || navigator.vendor || "";
  return (
    // Android WebView
    /\b; wv\)\b|\b; wv;\b|Version\/\d+\.\d+ Chrome\/\d+.* Mobile/i.test(ua) ||
    // iOS WebView (no Safari in UA)
    /(iPhone|iPad|iPod).+AppleWebKit(?!.*Safari)/i.test(ua) ||
    // WKWebView bridge
    (!!window.webkit && !!window.webkit.messageHandlers) ||
    // PWA standalone
    (window.matchMedia &&
      window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true ||
    // Popular in-app browsers
    /\bFBAN|FBAV|FB_IAB|FB4A|FBIOS|Instagram|Telegram|MicroMessenger|Line|Twitter\b/i.test(
      ua
    ) ||
    // Optional override (?inapp=1)
    new URLSearchParams(location.search).has("inapp")
  );
}

const routes = [
  {
    name: "DefaultComponent",
    component: DefaultComponent,
    path: "/",
    meta: { public: true },
  },
  {
    name: "ParentTabComponent",
    component: ParentTabComponent,
    path: "/token=:token",
    meta: { public: true },
  },

  {
    name: "ParentTabComponentAgency",
    component: ParentTabComponentAgency,
    path: "/tabcomponent_agency/token=:token",
    meta: { public: true },
  },

  {
    name: "LevelComponent",
    component: LevelComponent,
    path: "/Mylevel/leveltype=:leveltype/token=:token",
    meta: { public: true },
  },

  {
    name: "FansRankingTabs",
    component: FansRankingTabs,
    // path: '/fans_ranking/token=:token'
    path: "/fans_ranking/profileid=:profileid",
    meta: { public: true },
  },

  // LuckyNumber Game Url
  {
    name: "HistoryTabComponent",
    component: HistoryTabComponent,
    path: "/luckynumber/history-tab/user_id=:user_id",
    meta: { public: true },
  },
  {
    name: "StatisticsTabComponent",
    component: StatisticsTabComponent,
    // path: '/luckynumber/statistics',
    path: "/luckynumber/statistics/user_id=:user_id",
    meta: { public: true },
  },
  {
    name: "HistoryDetails",
    component: HistoryDetails,
    //path: '/luckynumber/history-details/:params',
    path: "/luckynumber/history-details/contest_id=:contest_id/user_id=:user_id",
    meta: { public: true },
  },
  {
    name: "LuckyNumberRules",
    component: LuckyNumberRules,
    path: "/luckynumber/rules",
    meta: { public: true },
  },
  {
    name: "LuckyRewards",
    component: LuckyRewards,
    path: "/luckynumber/lucky-rewards/profile_id=:profile_id",
    meta: { public: true },
  },

  // FlipCoin URl
  {
    name: "FlipCoinHistoryTabComponent",
    component: FlipCoinHistoryTabComponent,
    path: "/flipcoin/history-tab/user_id=:user_id",
    meta: { public: true },
  },
  {
    name: "FlipCoinHistoryDetails",
    component: FlipCoinHistoryDetails,
    path: "/flipcoin/history-details/contest_id=:contest_id/user_id=:user_id",
    meta: { public: true },
  },
  {
    name: "FlipCoinRules",
    component: FlipCoinRules,
    path: "/flipcoin/rules",
    meta: { public: true },
  },

  // Car Game  RankTabComponent

  {
    name: "RankTabComponent",
    component: RankTabComponent,
    path: "/cargame/rank",
    meta: { public: true },
  },
    {
    name: "RaceRewardsComponent",
    component: RaceRewardsComponent,
    path: "/cargame/reace-rewards/token=:token",
    meta: { public: true },
  },

  // Freetarget URl
  {
    name: "Freetarget",
    component: Freetarget,
    path: "/freetarget",
    meta: { public: true },
  },

  {
    name: "RewardBlastRule",
    component: RewardBlastRule,
    path: "/reward-blast-rule/token=:token",
    meta: { public: true },
  },

  {
    name: "WeeklyTargetRule",
    component: WeeklyTargetRule,
    path: "/weekly-target-rule/token=:token",
    meta: { public: true },
  },

  {
    name: "FreetargetUpdate",
    component: FreetargetUpdate,
    path: "/freetarget-update",
    meta: { public: true },
  },

  {
    name: "TopHosts",
    component: TopHosts,
    path: "/tophost_thisweek/token=:token",
    meta: { public: true },
  },

  // WeeklyTarget URl
  {   

    name: "TargetComponent",
    component: TargetComponent,
    // name: "WeeklyTarget",
    // component: WeeklyTarget,
    path: "/weeklytarget/token=:token",
    meta: { public: true },
  },
  {
    name: "WeeklyTargetPolicy",
    component: WeeklyTargetPolicy,
    path: "/weeklytarget_policy/token=:token",
    // path: "/weeklytarget_policy/token=:token(.*)?",
    meta: { public: true },
  },
  {
    name: "WeeklyTargetPolicyStatus3",
    component: WeeklyTargetPolicyStatus3,
    path: "/weeklytarget_policy_status3/token=:token",
    // path: "/weeklytarget_policy_status3/token=:token(.*)?",
    meta: { public: true },
  },

  // {
  //   name: "MidNightTarget",
  //   component: MidnightTarget,
  //     path: "/midnight-target/token=:token",
  //   meta: { public: true },
  // },

  // Become Agency

  // {
  //   name: "InviteAgency",
  //   component: InviteAgency,
  //   path: "/invite-agency/agency_profile_id=:profile_id",
  //   meta: { public: true },
  // },

  {
    name: "BecomeAgency",
    component: BecomeAgency,
    path: "/become_agency/profile_id=:profile_id",
    meta: { public: true },
  }, 
  
  {
    name: "GetAgentListFromAgency",
    component: GetAgentListFromAgency,
    path: "/get-agent-list/token=:token",
    meta: { public: true },
  },

  {
    name: "InviteSubAgent",
    component: InviteSubAgent,
    // path: "/invite-subagent/agency_profile_id=:profile_id",
    path: "/invite-subagent/token=:token",
    meta: { public: true },
  },

  {
    name: "CongratulationsScreen",
    component: CongratulationsScreen,
    // path: "/invite-subagent/agency_profile_id=:profile_id",
    path: "/become-agent-success",
    meta: { public: true },
  },

  // Agency Center
  {
    name: "AgencyCentre",
    component: AgencyCentre,
    path: "/agency-centre/token=:token",
    meta: { public: true },
  },
  {
    name: "AgencyTeamList",
    component: AgencyTeamList,
    path: "/agency-team-list/token=:token",
    meta: { public: true },
  },
  {
    name: "TeamIncomeOverview",
    component: TeamIncomeOverview,
    path: "/transaction-history",
    meta: { public: true },
  },

  {
    name: "gameCompaign",
    component: GameCompaign,
    path: "/gamecompaign/token=:token",
    meta: { public: true },
  },

  // Trade Acoount
  {
    name: "TradeAccount",
    component: TradeAccount,
    path: "/trade/trade-account/token=:token",
    meta: { public: true },
  },
  {
    name: "TradeTransectionHistory",
    component: TradeTransectionHistory,
    path: "/trade/transection-history",
    meta: { public: true },
  },

  {
    name: "PayoutHistory",
    component: PayoutHistory,
    // path: "/trade/payout-history/token=:token",
    path: "/trade/payout-history",
    meta: { public: true },
  },

  {
    name: "OnlineRechargeBonus",
    component: OnlineRechargeBonus,
    path: "/online-recharge-bonus",
    meta: { public: true },
  },
  
  {
    name: "GoldCoinBattle",
    component: GoldCoinBattle,
    path: "/goldcoin-battle/token=:token",
    meta: { public: true },
  },

  {
    name: "GoldCoinRewardRaceGame",
    component: GoldCoinRewardRaceGame,
    path: "/goldcoin-reward-race-game/token=:token",
    meta: { public: true },
  },

  {
    name: "EventCenter",
    component: EventCenter,
    path: "/event-center/token=:token",
    meta: { public: true },
  },

  { name: "NotAllowed", component: NotAllowed, path: "/not-allowed" },

];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // If route has meta.public → always allow
  if (to.meta.public) {
    return next();
  }
  if (!isInAppOrWebView() && to.name !== "NotAllowed") {
    // show local screen
    next({ name: "NotAllowed" }); 
  } else {
    next();
  }
});

export default router;